import React, {useState} from 'react';
import {Grid, Typography} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {Quote} from '../../../Core/mobx/ParameterStore/Quote';
import Card from '@material-ui/core/Card';
import {NumberFormatCustom, SwitchCustom, TextBox} from '../../../Core/UI';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {FormType} from '../../PreQualification/types';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/QuoteXref';

type TermTabProps = {
    valueChanged: (p: Parameter, value: any, formType?: FormType) => void;
    parameters: Quote;
    formType: FormType;
};

const TermTab = observer(({valueChanged, parameters, formType}: TermTabProps) => {
    const [error, setError] = useState({smokerRatingLSW: '', smokerRatingNA: '', specifiedFaceAmount: ''});

    const validateSpecifiedFaceAmount = () => {
        setError((prevState) => ({
            ...prevState,
            specifiedFaceAmount: +parameters.specifiedFaceAmount.value < 100000 ? 'specifiedFaceAmount >= 100000' : '',
        }));
    };

    const validateSmokerRatingLSW = () => {
        const {healthRatingLSW, smokerRatingLSW} = parameters;

        if (['Elite', 'Preferred', 'Select', 'Standard'].includes(healthRatingLSW.value)) {
            setError((prevState) => ({
                ...prevState,
                smokerRatingLSW: smokerRatingLSW.value === 'NonTobacco' ? '' : 'smokerRatingLSW == NonTobacco',
            }));
        }
        if (['Preferred', 'Standard'].includes(healthRatingLSW.value)) {
            setError((prevState) => ({
                ...prevState,
                smokerRatingLSW: smokerRatingLSW.value === 'Tobacco' ? '' : 'smokerRatingLSW == Tobacco',
            }));
        }
    };

    const validateSmokerRatingNA = () => {
        const {healthRatingNA, smokerRatingNA} = parameters;

        if (['Preferred', 'Standard'].includes(healthRatingNA.value)) {
            setError((prevState) => ({
                ...prevState,
                smokerRatingNA: smokerRatingNA.value === 'Tobacco' ? '' : 'smokerRatingNA == Tobacco',
            }));
        }
    };

    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    return (
        <>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Carrier Product</Typography>
                </div>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Product',
                                name: 'productTerm',
                                options: fieldOptions.productTerm.options,
                                optionValues: fieldOptions.productTerm.optionValues,
                                ...parameters.productTerm,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                </Grid>
            </Card>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Basics</Typography>
                </div>
                <Grid container spacing={3}>
                    {parameters.ameritas.value && (
                        <>
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Health Rating',
                                        name: 'healthRatingAmeritasTerm',
                                        options: fieldOptions.healthRatingAmeritasTerm.options,
                                        optionValues: fieldOptions.healthRatingAmeritasTerm.optionValues,
                                        ...parameters.healthRatingAmeritasTerm,
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Smoker Status',
                                        name: 'smokerRatingAmeritasTerm',
                                        options: fieldOptions.smokerRatingAmeritasTerm.options,
                                        ...parameters.smokerRatingAmeritasTerm,
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                />
                            </Grid>
                        </>
                    )}
                    {parameters.assurityLife.value && (
                        <>
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Smoker Status',
                                        name: 'smokerRatingAssurityTerm',
                                        options: fieldOptions.smokerRatingAssurityTerm.options,
                                        ...parameters.smokerRatingAssurityTerm,
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Health Rating',
                                        name: 'healthRatingAssurityTerm',
                                        options: fieldOptions.healthRatingAssurityTerm.options,
                                        optionValues: fieldOptions.healthRatingAssurityTerm.optionValues,
                                        ...parameters.healthRatingAssurityTerm,
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                />
                            </Grid>
                        </>
                    )}
                    {parameters.lsw.value && (
                        <>
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Health Rating',
                                        name: 'healthRatingLSW',
                                        options: fieldOptions.healthRatingLSW.options,
                                        optionValues: fieldOptions.healthRatingLSW.optionValues,
                                        ...parameters.healthRatingLSW,
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                />
                                <small>
                                    Note: For Express Standard 1 or Express Tobacco, select Standard and Table A; for
                                    Express Standard 2, select Standard and Table B
                                </small>
                            </Grid>
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Smoker Status',
                                        name: 'smokerRatingLSW',
                                        options: fieldOptions.smokerRatingLSW.options,
                                        ...parameters.smokerRatingLSW,
                                    }}
                                    error={!!error.smokerRatingLSW}
                                    helperText={error.smokerRatingLSW}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                    onBlur={validateSmokerRatingLSW}
                                />
                            </Grid>
                        </>
                    )}
                    {parameters.northAmerican.value && (
                        <>
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Health Rating',
                                        name: 'healthRatingNA',
                                        options: fieldOptions.healthRatingNA.options,
                                        ...parameters.healthRatingNA,
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Smoker Status',
                                        name: 'smokerRatingNA',
                                        options: fieldOptions.smokerRatingNA.options,
                                        ...parameters.smokerRatingNA,
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                    error={!!error.smokerRatingNA}
                                    helperText={error.smokerRatingNA}
                                    onBlur={validateSmokerRatingNA}
                                />
                            </Grid>
                        </>
                    )}

                    {(parameters.ameritas.value || parameters.assurityLife.value) &&
                        (parameters.healthRatingAmeritasAdult.value === 'NonTobacco' ||
                            parameters.healthRatingAmeritasAdult.value === 'Tobacco' ||
                            parameters.healthRatingAmeritasTerm.value === 'Standard') && (
                            <Grid item xs={6}>
                                <SelectInputElement
                                    param={{
                                        label: 'Table Rating',
                                        name: 'tableRatingAmeritasTerm',
                                        options: fieldOptions.tableRatingAmeritasTerm.options,
                                        optionValues: fieldOptions.tableRatingAmeritasTerm.optionValues,
                                        ...parameters.tableRatingAmeritasTerm,
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                    formType={formType}
                                />
                            </Grid>
                        )}
                    {parameters.lsw.value && parameters.healthRatingLSW.value === 'Standard' && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Table Rating',
                                    name: 'tableRatingLSW',
                                    options: fieldOptions.tableRatingLSW.options,
                                    optionValues: fieldOptions.tableRatingLSW.optionValues,
                                    ...parameters.tableRatingLSW,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    {parameters.northAmerican.value && parameters.healthRatingNA.value === 'Standard' && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Table Rating',
                                    name: 'tableRatingNA',
                                    options: fieldOptions.tableRatingNA.options,
                                    optionValues: fieldOptions.tableRatingNA.optionValues,
                                    ...parameters.tableRatingNA,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <SwitchCustom
                            param={{
                                name: 'flatExtra',
                                label: 'Flat Extra',
                                ...parameters.flatExtra,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    {parameters.flatExtra.value && (
                        <Grid item xs={12}>
                            <TextBox
                                id={'flatExtraPerm'}
                                label={'Policy Lifetime Flat Extra (per $1000)'}
                                value={parameters.flatExtraPerm?.value}
                                onChange={(value) => valueChanged(parameters.flatExtraPerm, value, formType)}
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                            />
                        </Grid>
                    )}
                    {parameters.flatExtra.value && (parameters.ameritas.value || parameters.northAmerican.value) && (
                        <>
                            <Grid item xs={6}>
                                <TextBox
                                    id={'flatExtraYears'}
                                    label={'Temporary Flat Extra Years'}
                                    value={parameters.flatExtraYears?.value}
                                    onChange={(value) => valueChanged(parameters.flatExtraYears, value, formType)}
                                    type="number"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextBox
                                    id={'flatExtraTemp'}
                                    label={'Temporary Flat Extra Amount (per $1000)'}
                                    value={parameters.flatExtraTemp?.value}
                                    onChange={(value) => valueChanged(parameters.flatExtraTemp, value, formType)}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Card>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Coverage and Premium</Typography>
                </div>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <TextBox
                            id={'specifiedFaceAmount'}
                            label={required('Specified Face Amount')}
                            value={parameters.specifiedFaceAmount?.value}
                            onChange={(value) => {
                                valueChanged(parameters.specifiedFaceAmount, value, formType);
                                validateSpecifiedFaceAmount();
                            }}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                            error={!!error.specifiedFaceAmount}
                            helperText={error.specifiedFaceAmount}
                        />
                    </Grid>
                    {parameters.productTerm.value !== 'AssurityLifeInsuranceCompanyTermLifeInsurance' && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Level Term Period',
                                    name: 'termPeriod',
                                    options: fieldOptions.termPeriod.options,
                                    ...parameters.termPeriod,
                                }}
                                required={required('')}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    {parameters.productTerm.value === 'AssurityLifeInsuranceCompanyTermLifeInsurance' && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Level Term Period',
                                    name: 'termPeriodAssurity',
                                    options: fieldOptions.termPeriodAssurity.options,
                                    ...parameters.termPeriodAssurity,
                                }}
                                required={required('')}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Premium Payment Frequency',
                                name: 'premiumFrequency',
                                options: fieldOptions.premiumFrequency.options,
                                optionValues: fieldOptions.premiumFrequency.optionValues,
                                ...parameters.premiumFrequency,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                </Grid>
            </Card>
            {(parameters.accidentalBenefit.value ||
                parameters.productTerm.value === 'AmeritasFLXLivingBenefitsTerm' ||
                parameters.productTerm.value === 'NorthAmericanTermADDvantage' ||
                parameters.productTerm.value === 'AssurityLifeInsuranceCompanyTermLifeInsurance') && (
                <Card
                    style={{
                        padding: 20,
                        marginBottom: 20,
                    }}
                >
                    <div>
                        <Typography style={{fontWeight: 'bold', fontSize: 24}}>Policy rider</Typography>
                    </div>
                    <Grid container spacing={3}>
                        {parameters.accidentalBenefit.value && (
                            <>
                                <Grid item xs={6}>
                                    <TextBox
                                        id={'accidentalBenefitAmount'}
                                        label={'Accidental Death Benefit Amount'}
                                        value={parameters.accidentalBenefitAmount?.value}
                                        onChange={(value) =>
                                            valueChanged(parameters.accidentalBenefitAmount, value, undefined)
                                        }
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <SelectInputElement
                                        param={{
                                            label: 'Accidental Benefit Rating',
                                            name: 'accidentalBenefitRating',
                                            options: fieldOptions.accidentalBenefitRating.options,
                                            optionValues: fieldOptions.accidentalBenefitRating.optionValues,
                                            ...parameters.accidentalBenefitRating,
                                        }}
                                        required={''}
                                        valueChanged={valueChanged}
                                        formType={formType}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextBox
                                        id={'accidentalBenefitToAge'}
                                        label={'Accidental Benefit To Age'}
                                        value={parameters.accidentalBenefitToAge?.value}
                                        onChange={(value) =>
                                            valueChanged(parameters.accidentalBenefitToAge, value, formType)
                                        }
                                        type="number"
                                    />
                                </Grid>
                            </>
                        )}
                        {(parameters.productTerm.value === 'AmeritasFLXLivingBenefitsTerm' ||
                            parameters.productTerm.value === 'NorthAmericanTermADDvantage' ||
                            parameters.productTerm.value === 'AssurityLifeInsuranceCompanyTermLifeInsurance') && (
                            <>
                                <Grid item xs={6}>
                                    <SwitchCustom
                                        param={{
                                            name: 'childrensRiderTermSelector',
                                            label: "Children's Rider",
                                            ...parameters.childrensRiderTermSelector,
                                        }}
                                        required={''}
                                        valueChanged={valueChanged}
                                        formType={formType}
                                    />
                                </Grid>
                                {parameters.childrensRiderTermSelector.value && (
                                    <Grid item xs={6}>
                                        <TextBox
                                            id={'childRiderUnitsTerm'}
                                            label={required("Children's Rider Units")}
                                            value={parameters.childRiderUnitsTerm?.value}
                                            onChange={(value) =>
                                                valueChanged(parameters.childRiderUnitsTerm, value, formType)
                                            }
                                            type="number"
                                        />
                                    </Grid>
                                )}
                            </>
                        )}
                    </Grid>
                </Card>
            )}
        </>
    );
});

export default TermTab;
